var render, staticRenderFns
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78eab95e')) {
      api.createRecord('78eab95e', component.options)
    } else {
      api.reload('78eab95e', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-2UrN8dzY3UzZZ/JS/feedback.vue"
export default component.exports